import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { mapDto } from '@shared/operators';
import { Lesson, LessonDto } from '../models';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private httpClient = inject(HttpClient);

    getLesson(id: string): Observable<Lesson> {
        return this.httpClient.get<LessonDto>(`library/lessons/${id}`).pipe(
            mapDto((response) => new Lesson(response)),
            catchError((error: HttpErrorResponse) => {
                if (error.status === 403) {
                    throw new Error('no-access');
                }
                throw error;
            }),
        );
    }
}
